/**
 * Note better to use isEqual lodash if dates are not involved
 * Returns whether objects are equal
 * @param obj1 Given object 1
 * @param obj2 Given object 2
 * @param setDateFormatting Whether the compare should remove the formatting and time from any given date component
 * @returns Whether the objects equal
 */
export const compareObjects = (obj1, obj2, setDateFormatting = false) => {
  const obj1Formatted = setDateFormatting ? formatDate(obj1) : obj1;
  const obj2Formatted = setDateFormatting ? formatDate(obj2) : obj2;
  return (
    JSON.stringify(orderObjectAlphabetically(obj1Formatted)) ===
    JSON.stringify(orderObjectAlphabetically(obj2Formatted))
  );
};

/**
 * @description orders a object alphabetically by the keys of the object
 * @param obj
 * @returns
 */
function orderObjectAlphabetically(obj) {
  if (!obj) return;
  // Get the keys of the object and sort them alphabetically
  const sortedKeys = Object.keys(obj).sort();

  // Create a new object with the sorted keys
  const sortedObj = {};

  // Iterate through sorted keys and populate the new object
  for (let key of sortedKeys) {
    sortedObj[key] = obj[key];
  }

  return sortedObj;
}

/**
 * Formats all date objects in an object to a string with the format MM/DD/YYYY.
 * @param obj - The object to format.
 * @returns The formatted object.
 */
function formatDate(obj: any) {
  if (obj instanceof Date) {
    return obj.toLocaleDateString('en-US', { timeZone: 'UTC' });
  } else if (typeof obj === 'object') {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] instanceof Date) {
          obj[key] = formatDate(obj[key]);
        } else if (typeof obj[key] === 'object') {
          formatDate(obj[key]);
        }
      }
    }
  }
  return obj;
}

/**
 *
 * @param compareObject
 * @example
 * const obj = { id: 'hello', name: 'world' }
 * differsBy({id: "hello"})(obj) // returns false;
 * // ----- More Examples + use cases:
 * const arrayOfObjects = [{id: "1", name: "hello", type: "some"}, {id: "2", name: "world", type: "some"}];
 * arrayOfObjects.filter( differsBy({name: "hello"}) ) // returns [{ id: "2", name: "world", type: "some" }]
 * arrayOfObjects.some( differsBy({ type: "some" }) ) //returns false
 */
export const differsBy =
  <T extends { [key: string]: any }>(compareObject: Partial<T>) =>
  (comparedObject: T) =>
    Object.keys(compareObject).every(key => compareObject[key] !== comparedObject[key]);
